import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Stack } from '@mui/material';
import { format, isValid, parse } from 'date-fns';
import { FC } from 'react';

import { dateOnlyFormat } from 'portal/src/validators/dateValidator';

const InsightDetailsPanel: FC<{
  details: {
    type?: string;
    priority?: string;
    utility?: string;
    account?: string;
    meter?: string;
    facility?: string;
    message?: string;
    resolution?: string;
    resolutionUrl?: string | null;
    date?: string;
  };
}> = ({ details }) => {
  const parsedDate = parse(details.date, dateOnlyFormat, new Date());

  return (
    <Stack sx={{ backgroundColor: 'grey.100' }}>
      <ul style={{ marginLeft: '100px' }}>
        <li>
          <strong>Type</strong>: {details.type || ''}
        </li>
        <li>
          <strong>Priority</strong>: {details.priority || ''}
        </li>
        <li>
          <strong>Utility</strong>: {details.utility || ''}
        </li>
        <li>
          <strong>Account</strong>: {details.account || ''}
        </li>
        <li>
          <strong>Meter</strong>: {details.meter || ''}
        </li>
        <li>
          <strong>Facility</strong>: {details.facility || ''}
        </li>
        <li>
          <strong>Message</strong>: {details.message || ''}
        </li>
        <li>
          <strong>Potential Resolution</strong>: {details.resolution || ''}
        </li>
        <li>
          <strong>Date</strong>:{' '}
          {isValid(parsedDate) ? format(parsedDate, 'P') : ''}
        </li>
        {details.resolutionUrl && (
          <Button
            onClick={(e) => {
              e.preventDefault();
              window.open(
                details.resolutionUrl,
                '_blank',
                'noopener,noreferrer',
              );
            }}
            variant="contained"
            size="small"
            color="primary"
            role="link"
            sx={{ mt: 1, display: 'flex', alignItems: 'flex-start', gap: 1 }}
          >
            Resolve Here <OpenInNewIcon fontSize="small" />
          </Button>
        )}
      </ul>
    </Stack>
  );
};

export default InsightDetailsPanel;
